import React from 'react';

import { Form } from 'antd';
import { FormItemProps } from 'antd/lib/form/FormItem';
import { TextAreaProps } from 'antd/lib/input';

import { Input, InputProps } from 'components/Input';
import { TextArea } from 'components/TextArea';

type FormInputProps = FormItemProps & Omit<InputProps, 'name'>;

type ComponentProps = {
  postValueChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  isLoading?: boolean;
};

export type Props = ComponentProps & FormInputProps;

export const InputFormItem = ({
  label,
  name,
  rules,
  type,
  help,
  validateStatus,
  disabled,
  defaultValue,
  value,
  getValueFromEvent,
  postValueChange,
  prefix,
  suffix,
  ...otherProps
}: Props): JSX.Element => (
  <Form.Item
    name={name}
    label={label}
    rules={rules}
    help={help}
    validateStatus={validateStatus}
    getValueFromEvent={getValueFromEvent}
  >
    <Input
      type={type}
      disabled={disabled}
      defaultValue={defaultValue}
      value={value}
      onChange={(event) => {
        if (postValueChange) {
          postValueChange(event);
        }
      }}
      prefix={prefix}
      suffix={suffix}
      {...otherProps}
    />
  </Form.Item>
);

export const TextAreaFormItem = ({
  label,
  name,
  rules,
  help,
  validateStatus,
  disabled,
  defaultValue,
  value,
  getValueFromEvent,
  postValueChange,
  prefix,
  ...otherProps
}: TextAreaProps & FormItemProps & ComponentProps): JSX.Element => {
  const handleChange: {
    (e: React.ChangeEvent<HTMLInputElement>): void;
    (e: React.ChangeEvent<HTMLTextAreaElement>): void;
  } = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (postValueChange) {
      postValueChange(e);
    }
  };

  return (
    <Form.Item
      name={name}
      label={label}
      rules={rules}
      help={help}
      validateStatus={validateStatus}
      getValueFromEvent={getValueFromEvent}
    >
      <TextArea
        disabled={disabled}
        defaultValue={defaultValue}
        value={value}
        onChange={handleChange}
        prefix={prefix}
        rows={6}
        wrap="soft"
        {...otherProps}
      />
    </Form.Item>
  );
};
